import * as requisicoesStore from './store'

export function requisicoesModule({ store }) {
  store.registerModule('requisicoes', {
    ...requisicoesStore,
    namespaced: true,
  })
}
